import pickerLocale from "antd/lib/date-picker/locale/de_DE"
import dayjs from "dayjs";
import styled from "styled-components";
import { InputStyled } from "./form-item-string";
import { useAdvancedFormContext } from "../advanced-form";
import { useCallback } from "react";
import LocalizedDatePicker from "../../util/localized-date-picker";

const DatePickerStyled = styled(LocalizedDatePicker)`
  width: 100%;
`

function DatePickerWrapper({ placeholder, value, onChange, readOnly }: any) {
  if(typeof value === "string") {
    value = dayjs(value);
  } 
  
  if(value) {
    const oldValue = value;
    value = value.hour(0).minute(0).second(0).millisecond(0);
    if(oldValue.valueOf() !== value.valueOf()) {
      onChange(value)
    }
  }

  const onChangeInternal = useCallback(v => {
    console.log("On change date", v)
    onChange(v === null ? null : v.hour(0).minute(0).second(0).millisecond(0))
  }, [onChange])

  const onKeyDown = useCallback(evt => {
    const nextString = "" + (evt.target as any).value + evt.key
    const m = nextString.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/)
    if(m) {
      //console.log("String matches date", m)
      let year = parseInt(m[3]);
      if(m[3].length === 2) {
        year += 2000;
      }
      onChange(dayjs().year(year).month(parseInt(m[2]) - 1).date(parseInt(m[1])).hour(0).minute(0).second(0));
    }
  }, [onChange])

  return (
    <DatePickerStyled locale={pickerLocale} disabled={readOnly} placeholder={placeholder} format={'DD.MM.YYYY'} value={value} onChange={onChangeInternal} onKeyDown={onKeyDown} />
  )
}

function FormItemDate({ readOnly, disabled, label, value, onChange, typeData }: any) {
  const advancedFormContext = useAdvancedFormContext()
  const effectiveReadOnly = readOnly || advancedFormContext?.readOnly

  return (
    <>
      { effectiveReadOnly &&  <InputStyled value={value ? dayjs(value).format('DD.MM.YYYY') : undefined} readOnly />}
      { !effectiveReadOnly && <DatePickerWrapper value={value} onChange={onChange} readOnly={readOnly} disabled={disabled} placeholder={label} picker={typeData?.picker} /> }
    </>
  )
}

export default FormItemDate;